import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { AsyncPipe, NgIf, NgStyle } from '@angular/common';
import { SharedModule } from '../../../shared.module';
import { ColumnComponent } from '../column.component';
import { exists } from '../../../../../functions/exists';
import { StringUtils } from '../../../../../utils/string-utils';
import { type SectionColumnConfigDataValue } from '../../../../../models/enum/shared/section-column-config-data-value';
import type { SectionColumnType } from '../../../../../models/enum/shared/section-column-type';
import { ColumnListLayoutModifierClass } from 'src/app/models/enum/shared/column-list-layout-types';
import { SectionColumnTerpeneType } from 'src/app/models/enum/shared/section-column-terpene-type';
import { BadgeAsset } from 'src/app/models/image/dto/badge-asset';

@Component({
  selector: 'app-column-terpene',
  imports: [AsyncPipe, NgIf, NgStyle, SharedModule],
  templateUrl: './column-terpene.component.html',
  styleUrl: './column-terpene.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ColumnTerpeneComponent extends ColumnComponent implements AfterViewInit, OnChanges, OnInit {
  constructor(protected renderer: Renderer2) {
    super();
  }

  @ViewChild('terpeneColumn') terpeneColumn: ElementRef<HTMLDivElement>;
  @Input() useNgContent: boolean;
  @Input() terpeneColumnType: SectionColumnType;
  @Input() displayFormat: SectionColumnConfigDataValue;
  @Input() columnListLayoutModifierClass: ColumnListLayoutModifierClass = null;
  private currentTerpeneClass: string;
  isTopTerpeneColumn: boolean;
  isListTerpeneColumn: boolean;
  isOtherColumn: boolean;

  ngOnInit(): void {
    super.ngOnInit();
    this.isTopTerpeneColumn = this.colVm.columnType === SectionColumnTerpeneType.TopTerpene;
    this.isListTerpeneColumn = this.colVm.columnType === SectionColumnTerpeneType.ListTerpenes;
    this.isOtherColumn =
      this.colVm.columnType === this.terpeneColumnType && !(this.isTopTerpeneColumn || this.isListTerpeneColumn);
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.updateClass();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.cannabinoidColumnType) this.updateClass();
  }

  getNonListColumnItem(): BadgeAsset | string | undefined {
    if (this.colVm.columnConfigDataValueIsBadgeMode()) {
      return this.rowVm.getBadgeAssetForColumnType(SectionColumnTerpeneType.TopTerpene)?.image;
    }
    return this.rowVm.getTopTerpene();
  }

  private updateClass(): void {
    if (exists(this.terpeneColumn?.nativeElement)) {
      this.renderer.removeClass(this.terpeneColumn.nativeElement, this.currentTerpeneClass);
      this.currentTerpeneClass = `product-${StringUtils.pascalCaseToKebabCase(this.terpeneColumnType)}`;
      this.renderer.addClass(this.terpeneColumn.nativeElement, this.currentTerpeneClass);
    }
  }
}
